export const nav = {
  allAds: "Todos los anuncios",
  createAd: "Crear anuncio",
  pricing: "Precios",
  tips: "Consejos",
  about: "Sobre Sellavo",
  help: "Ayuda y soporte",
  inboxUnread: "Bandeja de entrada – {{count}} sin leer. Ábrela para leerlos.",
  inboxUnreadTitle: "{{count}} sin leer{{suffix}} – abre la bandeja de entrada para marcarlos como leídos",
  adminPending: "{{count}} asuntos de administración en espera{{support}}",
  adminPendingSupport: " – de los cuales {{count}} soporte",
  sellavoHome: "Sellavo – volver a la página de inicio",
} as const;

export const footer = {
  colSellavo: "Sellavo",
  colTrade: "Vender y comprar",
  colLegal: "Legal",
  om: "Sobre Sellavo",
  howItWorks: "Cómo funciona",
  whyItCosts: "¿Por qué cuesta?",
  pricing: "Precios",
  tips: "Consejos",
  guides: "Guías",
  buyAndSellLocally: "Comprar y vender en tu zona",
  compare: "Comparar sitios de venta",
  rules: "Reglas de anuncios",
  videoScan: "Escaneo de vídeo",
  help: "Ayuda y soporte",
  terms: "Términos de uso",
  privacy: "Política de privacidad",
  cookies: "Política de cookies",
  cookieSettings: "Ajustes de cookies",
  tagline: "Haz una foto, deja que la IA escriba el anuncio y vende rápido y bien.",
} as const;

export const errors = {
  notFoundTitle: "Página no encontrada",
  notFoundBody: "La dirección que intentaste abrir no existe o la página se ha movido.",
  offlineTitle: "Sin conexión",
  offlineBody:
    "No podemos conectar con Sellavo ahora mismo. Comprueba tu conexión e inténtalo de nuevo — las páginas que visitaste antes siguen funcionando.",
  busyTitle: "Muchos visitantes ahora mismo",
  busyBody: "Hay más visitantes de lo habitual en Sellavo. Espera unos segundos e inténtalo de nuevo.",
  errorTitle: "No se pudo cargar la página",
  errorBody: "Algo ha fallado en nuestro lado. Prueba a recargar la página o vuelve a la página de inicio.",
} as const;
